import * as go from 'gojs';
import { getImageSchenckScreen } from 'unitData/SchenckScreen/getImageSchenckScreen';
import { InputPort } from '../../../portTemplates/inputPortTemplate';
import { OutputPort } from '../../../portTemplates/outputPortTemplate';
import { BaseUnit } from '../../Panels/baseUnitPanel';
import { getSelectionAdornment } from '../../utils';
import { PanelNames } from '../../utils/panelNames';
import type { ScreenNodeData } from 'gojs/types';
import {
  handleFreePortArrowSelectionChanged,
  hideFreePortHoverArrows,
  showFreePortHoverArrows,
} from '../../utils/freePortHoverArrows';

const $ = go.GraphObject.make;

const alignScreenPort = (
  mirrored: boolean,
  decks: number,
  portIndex: number,
) => {
  const x = mirrored ? 0 : 1;

  if (decks === 1) {
    switch (portIndex) {
      case 1:
        return new go.Spot(x, 5 / 6);
      case 2:
        return new go.Spot(0.5, 1);
    }
  } else if (decks === 2) {
    switch (portIndex) {
      case 1:
        return new go.Spot(x, 4 / 6);
      case 2:
        return new go.Spot(x, 5 / 6);
      case 3:
        return new go.Spot(0.5, 1);
    }
  }
};

const SchenckScreenTemplate = $(
  go.Node,
  {
    layerName: 'Foreground',
    mouseEnter: (_e, obj) => showFreePortHoverArrows(obj.part as go.Node),
    mouseLeave: (_e, obj) => hideFreePortHoverArrows(obj.part as go.Node),
    selectionChanged: handleFreePortArrowSelectionChanged,
  },
  'Table',
  $(go.RowColumnDefinition, { row: 0, alignment: go.Spot.Top }),
  $(go.RowColumnDefinition, { row: 2, alignment: go.Spot.Bottom }),
  getSelectionAdornment(),
  new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
    go.Point.stringify,
  ),

  $(
    go.Panel,
    'Spot',
    {
      row: 1,
      column: 1,
      name: 'BODY',
      stretch: go.GraphObject.Fill,
    },
    $(
      go.Shape,
      'RoundedRectangle',
      {
        name: PanelNames.UNIT_NODE_SELECTION_SHAPE,
        strokeWidth: 0,
        width: 96,
        height: 96,
        parameter1: 8,
        opacity: 0,
      },
      new go.Binding(
        'fill',
        'isSelected',
        (sel: ScreenNodeData['selected']) => {
          return sel ? '#E6F5FF' : '#F6F6F6';
        },
      ).ofObject(),
    ),
    $(
      go.Picture,
      { width: 80, height: 80 },
      new go.Binding(
        'flip',
        'mirrored',
        (mirrored: ScreenNodeData['mirrored']) => {
          return mirrored === true
            ? go.GraphObject.FlipHorizontal
            : go.GraphObject.None;
        },
      ),
      new go.Binding(
        'source',
        'decks',
        (nbrOfDecks: ScreenNodeData['nbrOfDecks']) => {
          return getImageSchenckScreen(nbrOfDecks);
        },
      ),
    ),
    $(
      go.Panel,
      'Auto',
      new go.Binding('itemArray', 'D0'),
      {
        itemTemplate: OutputPort,
      },
      new go.Binding('alignment', '', (node: ScreenNodeData) => {
        return alignScreenPort(node.mirrored, node.nbrOfDecks, 1);
      }),
    ),
    $(
      go.Panel,
      'Auto',
      new go.Binding('itemArray', 'D1'),
      {
        itemTemplate: OutputPort,
      },
      new go.Binding('alignment', '', (node: ScreenNodeData) => {
        return alignScreenPort(node.mirrored, node.nbrOfDecks, 2);
      }),
    ),
    $(
      go.Panel,
      'Auto',
      new go.Binding('itemArray', 'D2'),
      {
        itemTemplate: OutputPort,
      },
      new go.Binding('alignment', '', (node: ScreenNodeData) => {
        return alignScreenPort(node.mirrored, node.nbrOfDecks, 3);
      }),
    ),
    $(go.Panel, 'Horizontal', new go.Binding('itemArray', 'inputPortArray'), {
      alignment: go.Spot.Top,
      itemTemplate: InputPort,
    }),
    BaseUnit(),
  ),
);

export default SchenckScreenTemplate;
